module.exports = "/src/views/player/help/images/247.jpg";